import { Box, Grid, Typography, } from "@mui/material";
import React, { useEffect, useState } from "react";
import { dashboardIcon, region, taskAssign, userManagement, } from "../../config/images";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import translations from "../../config/language";
import { Button } from "../../components/Button/button";
import { deactivateDataCollectorList, getDataCollectorListDetails, getUserId, updateAdminStatus, updateUserProfile, } from "../../config/services";
import { notifyError, notifySuccess } from "../../config/ToastMessage";
import { useSelector } from "react-redux";

const UserManagementDetail = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);
  const [formValues, setFormValues] = useState({
    profileImage: null,
    firstName: "",
    middleName: "",
    lastName: "",
    gender: "",
    mobileNumber: "",
    email: "",
    isActive: "",
  });
  const [userImage, setUserImage] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [userData, setUserData] = useState({});
  const language = process.env.REACT_APP_LANGUAGE;

  const params = useParams();
  const { module_access } = useSelector((state) => state.userState)
  const isAccess = module_access?.find((module) =>
    module.module_name === "User Management" && module.is_editor === true
  ) ? true : false;

  const handleBackClick = () => {
    const currentPage = new URLSearchParams(window.location.search).get("page");
    navigate(`/user-management?page=${currentPage}`);
  };

  const handleEdit = async (e) => {
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    e.preventDefault();
    const formData = new FormData();

    if (userImage) {
      // User uploaded a new image, use the selected file
      formData.append("profile_photo", userImage);
    }
    formData.append("first_name", formValues.firstName);
    formData.append("middle_name", formValues.middleName);
    formData.append("last_name", formValues.lastName);
    formData.append("gender", formValues.gender === "Male" ? 0 : 1);
    formData.append("mobile_number", formValues.mobileNumber);
    formData.append("email", formValues.email);

    try {
      const resp = await updateUserProfile(params.id, formData);

      if (resp.data.success) {
        notifySuccess(resp.data.message);
      }
    } catch (error) {
      notifyError(error.message);
    }
  };

  useEffect(() => {
    handleUserData();
  }, [params.id]);

  const handleUserData = async () => {
    try {
      const resp = await getUserId(params.id);
      setUserData(resp.data);
    } catch (err) {
      setUserData({});
    }
  };

  const handleChange = (e) => {
    setFormValues({ ...formValues, [e.target.name]: e.target.value });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormValues({ ...formValues, profileImage: reader.result });
      };
      reader.readAsDataURL(file);
    }
    setUserImage(file);
  };

  useEffect(() => {
    setFormValues({
      ...formValues,
      firstName: userData.first_name,
      middleName: userData.middle_name,
      lastName: userData.last_name,
      gender: userData.gender,
      mobileNumber: userData.mobile_number,
      email: userData.email,
      role: userData.role,
      isActive: userData.is_active,
      profileImage: userData.profile_photo,
    });
  }, [userData]);


  const fetchData = async () => {
    try {
      setLoading(true);
      const resp = await getDataCollectorListDetails(params.id);
      if (resp.data) {
        setFormValues({
          profileImage: resp.data.profile_photo || "",
          firstName: resp.data.first_name || "",
          middleName: resp.data.middle_name || "",
          lastName: resp.data.last_name || "",
          gender: resp.data.gender,
          mobileNumber: resp.data.mobile_number || "",
          email: resp.data.email || "",
          role: resp.data.role || "",
          isActive: resp.data.is_active,
        });
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  };

  const handleDeactive = async () => {
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    try {
      const id = params.id;

      const data = {
        is_active: !formValues.isActive,
        user_id: params.id,
      };
      const resp = await deactivateDataCollectorList(id, data);
      if (resp.data.success == true) {
        fetchData();
        notifySuccess(resp.data.message);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const location = useLocation();

  useEffect(() => {
    const action = location.state?.action || "view";
    setIsEdit(action === "edit");
  }, []);

  const handleApprove = async () => {
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    // APPROVED = 13, ("Approved")
    // REJECT = 14, ("Reject")
    const data = {
      admin_id: params.id,
      status: 13,
    }
    try {
      const resp = await updateAdminStatus(data);
      if (resp.data.success == true) {
        notifySuccess(resp.data.message);
      }
    } catch (error) {
      console.log("error", error);
      notifyError(error.response.data.message);
    }
  };

  const handleReject = async () => {
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    //     APPROVED = 13, ("Approved")
    // REJECT = 14, ("Reject")

    const data = {
      admin_id: params.id,
      status: 14,
    }
    try {
      const resp = await updateAdminStatus(data);
      if (resp.data.success == true) {
        notifySuccess(resp.data.message);
      }
    } catch (error) {
      console.log("error", error);
      notifyError(error.response.data.message);
    }
  };
  return (
    <>
      <Box className="task-detail-box">
        <Box className="d-flex justify-content-between align-items-center">
          <Box className="d-flex gap-3 img-box" style={{ padding: "25px" }}>
            <img
              src={taskAssign.backArrow}
              alt=""
              style={{ height: "44px", width: "44px", cursor: "pointer" }}
              onClick={() => handleBackClick()}
            />
            <img
              src={userManagement.userManagementIcon}
              alt=""
            />
            <Typography variant="h6" gutterBottom>
              {translations[language].userManagement}
            </Typography>
          </Box>
          <div className="edit-profile">
            {location.state?.status === "pending" ? (
              <>
                <button
                  className="custom-button"
                  style={{ marginRight: "10px" }}
                  onClick={() => handleApprove()}
                >
                  {translations[language].approve}
                </button>
                <button
                  className="deactivate-btn"
                  onClick={() => handleReject()}
                >
                  {translations[language].reject}
                </button>
              </>
            ) : (
              <>
                <button
                  className="deactivate-btn"
                  style={{ height: "46px" }}
                  onClick={handleDeactive}
                >
                  {formValues.isActive ? "Deactivate" : "Activate"}
                </button>
                {isEdit && (
                  <Button
                    title={translations[language].update}
                    classname={"custom-button"}
                    onClick={handleEdit}
                    style={{ letterSpacing: "0.5px", width: "100px" }}
                  />
                )}
              </>
            )}
          </div>
        </Box>

        <Box className="user-profile">
          <Grid container spacing={2}>
            <Grid item xs={12} md={8} lg={8}>
              {[
                "firstName",
                "middleName",
                "lastName",
                "gender",
                "mobileNumber",
                "email",
                "role",
                "isActive",
              ].map((field, index) => {
                return (
                  <Grid container key={index} style={index === 0 ? { borderTop: "1px solid #D9D9D9" } : {}} >
                    <Grid item xs={12} sm={4} md={3} lg={3} className="grid-item" style={{ paddingLeft: "20px" }} >
                      {field == "firstName"
                        ? translations[language].firstName
                        : field == "middleName"
                          ? translations[language].middleName
                          : field == "lastName"
                            ? translations[language].lastName
                            : field == "gender"
                              ? translations[language].gender
                              : field == "mobileNumber"
                                ? translations[language].mobileNumber
                                : field == "email"
                                  ? translations[language].email
                                  : field == "role"
                                    ? translations[language].role
                                    : translations[language].status}
                    </Grid>
                    <Grid item xs={12} sm={8} md={9} lg={9} className="grid-item">
                      {field === "gender" && isEdit && location.state?.status !== "pending" ? (
                        <div style={{ display: "flex", gap: "10px" }}>
                          <input
                            type="radio"
                            name="gender"
                            value={translations[language].male}
                            checked={formValues.gender == 0 || formValues.gender == "Male"}
                            onChange={handleChange}
                          />
                          <label
                            htmlFor="Male"
                            style={{
                              paddingRight: "10px",
                              borderRight: "1px solid  #D9D9D9",
                            }}
                          >
                            {translations[language].male}
                          </label>
                          <input
                            type="radio"
                            name="gender"
                            value={translations[language].female}
                            checked={formValues.gender == 1 || formValues.gender == "Female"}
                            onChange={handleChange}
                          />
                          <label htmlFor="Female">
                            {translations[language].female}
                          </label>
                        </div>
                      ) : field === "gender" ? (
                        <input
                          type="text"
                          value={formValues.gender == 0 ? "Male" : "Female"}
                          name={field}
                          disabled
                          style={{
                            width: "100%",
                            border: "none",
                            background: "none",
                          }}
                        />
                      ) : field === "isActive" ? (
                        <input
                          type="text"
                          value={formValues.isActive ? "Active" : "Inactive" || "-"}
                          name={field}
                          disabled
                          style={{
                            width: "100%",
                            border: "none",
                            background: "none",
                          }}
                        />
                      ) : (
                        <input
                          type="text"
                          value={formValues[field] || "-"}
                          name={field}
                          disabled={!isEdit || field === "isActive" || location.state?.status === "pending"}
                          onChange={handleChange}
                          style={{
                            width: "100%",
                            border: "none",
                            background: "none",
                            cursor: !isEdit || field === "isActive" || location.state?.status === "pending" ? "not-allowed" : "text"
                          }}
                        />
                      )}
                    </Grid>
                  </Grid>
                );
              })}
            </Grid>
            <Grid item xs={12} md={4} lg={4}>
              <div style={{ position: "relative", width: "100%" }}>
                {location.state?.status === "pending" ? (
                  <img
                    src={formValues.profileImage || dashboardIcon.profile}
                    alt="user-image"
                    className="user-image"
                    style={{ height: "316px", width: "100%" }}
                  />
                ) : formValues.profileImage ? (
                  // Case 1 & 2: When profile image exists
                  <>
                    <img
                      src={formValues.profileImage}
                      alt="user-image"
                      className="user-image"
                      style={{ height: "316px", width: "100%" }}
                    />
                    {isEdit && (
                      <label
                        htmlFor="profile-image-input"
                        style={{
                          position: "absolute",
                          top: "10px",
                          right: "30px",
                          cursor: "pointer",
                        }}
                      >
                        <img src={dashboardIcon.editIcon} alt="edit-icon" />
                      </label>
                    )}
                  </>
                ) : (
                  // Case 3 & 4: When no profile image
                  <>
                    {isEdit ? (
                      // Case 3: No image but edit mode
                      <>
                        <label htmlFor="profile-image-input" style={{ width: "100%" }}>
                          <Box
                            sx={{
                              width: "100%",
                              height: "316px",
                              border: "2px dashed #3C4856",
                              borderRadius: "8px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              cursor: "pointer",
                              overflow: "hidden",
                              backgroundColor: "#fff",
                              boxShadow: "0px 4px 10px rgba(160, 160, 160, 0.16)",
                            }}
                          >
                            <img src={region.browseImage} alt="" />
                          </Box>
                        </label>
                      </>
                    ) : (
                      // Case 4: No image and view mode
                      <>
                        <img
                          src={dashboardIcon.profile}
                          alt="user-image"
                          className="user-image"
                          style={{ height: "316px", width: "100%" }}
                        />
                      </>
                    )}
                  </>
                )}
                {isEdit && (
                  <input
                    id="profile-image-input"
                    type="file"
                    accept="image/*"
                    style={{ display: "none" }}
                    onChange={handleImageChange}
                  />
                )}
              </div>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default UserManagementDetail;